export default {
  SET_STATE: 'reports/SET_STATE',
  FETCH_REPORTS: 'reports/FETCH_REPORTS',
  // CREATE_REPORT: 'REPORTs/CREATE_REPORT',
  FETCH_SINGLE: 'reports/FETCH_SINGLE',
  // UPDATE_PAYMENT: 'payments/UPDATE_PAYMENT',
}
